import { apiClient } from './client';

export interface ShopItem {
  id: string;
  shopId: string;
  type: string;
  name: string;
  description: string | null;
  price: number;
  previewUrl: string | null;
  metadata: Record<string, unknown>;
  stock: number | null;
  sold: number;
  shop?: { id: string; name: string; owner: { username: string; displayName: string } };
}

export interface UserCosmetic {
  id: string;
  userId: string;
  type: string;
  itemId: string;
  data: Record<string, unknown>;
  equipped: boolean;
  createdAt: string;
  item: { id: string; name: string; type: string; previewUrl: string | null; price: number };
}

export const shopApi = {
  async listItems(type?: string): Promise<ShopItem[]> {
    const { data } = await apiClient.get('/api/shop/items', { params: type ? { type } : {} });
    return data;
  },

  async buyItem(itemId: string): Promise<{ order: unknown; cosmetic: unknown }> {
    const { data } = await apiClient.post(`/api/shop/buy/${itemId}`);
    return data;
  },

  async getInventory(): Promise<UserCosmetic[]> {
    const { data } = await apiClient.get('/api/shop/inventory/me');
    return data;
  },

  async equipCosmetic(cosmeticId: string): Promise<{ equipped: boolean }> {
    const { data } = await apiClient.post(`/api/shop/equip/${cosmeticId}`);
    return data;
  },
};
